import {
	REPLACEMENT_VEHICLE_CREATE,
	REPLACEMENT_VEHICLE_CREATE_SUCCESS,
	REPLACEMENT_VEHICLE_CREATE_ERROR,
	REPLACEMENT_VEHICLE_DELETE,
	REPLACEMENT_VEHICLE_DELETE_SUCCESS,
	REPLACEMENT_VEHICLE_DELETE_ERROR,
	REPLACEMENT_VEHICLES_LIST_FILTERED,
	REPLACEMENT_VEHICLES_LIST_FILTERED_SUCCESS,
	REPLACEMENT_VEHICLES_LIST_FILTERED_ERROR,
	REPLACEMENT_VEHICLES_ALL,
	REPLACEMENT_VEHICLES_ALL_SUCCESS,
	REPLACEMENT_VEHICLES_ALL_ERROR,
	USER_REPLACEMENT_VEHICLES_DEPARTMENT_FILTER,
	REPLACEMENT_VEHICLE_CHANGE_IMAGE,
	REPLACEMENT_VEHICLE_CHANGE_IMAGE_ERROR,
	REPLACEMENT_VEHICLE_CHANGE_IMAGE_SUCCESS,
	REPLACEMENT_VEHICLE_GET_LATEST_KM_AND_FUEL,
	REPLACEMENT_VEHICLE_GET_LATEST_KM_AND_FUEL_ERROR,
	REPLACEMENT_VEHICLE_GET_LATEST_KM_AND_FUEL_SUCCESS,
	REPLACEMENT_VEHICLE_GET_PREVIOUS_AND_NEXT_RESERVATION,
	REPLACEMENT_VEHICLE_GET_PREVIOUS_AND_NEXT_RESERVATION_ERROR,
	REPLACEMENT_VEHICLE_GET_PREVIOUS_AND_NEXT_RESERVATION_SUCCESS,
} from "../actions/replacementVehicles";
import Vue from "vue";
import ReplacementVehiclesService from '@/services/replacementVehicles';

const state = {
	status: '',
	userReplacementVehiclesDepartmentFilter: null,
};

const getters = {
	getUserReplacementVehiclesDepartmentFilter: state => state.userReplacementVehiclesDepartmentFilter,
};

const actions = {
	[REPLACEMENT_VEHICLE_CREATE]: ({ commit, dispatch }, data) => {
		const tiresSeason = data.replacementVehicle.workflow_status ? data.replacementVehicle.workflow_status.value : null;
		const department = data.replacementVehicle.department ? data.replacementVehicle.department.value : null;
		let requestData = {
			id: data.replacementVehicle.id,
			vin: data.replacementVehicle.vin,
			brand_id: data.replacementVehicle.brand_id,
			model: data.replacementVehicle.model,
			annual_service_date: data.replacementVehicle.annual_service_date,
			registration_date: data.replacementVehicle.registration_date,
			responsible_person: data.replacementVehicle.responsible_person,
			responsible_person_id: data.replacementVehicle.responsible_person_id,
			own_vehicle: data.replacementVehicle.own_vehicle,
			workflow_status: tiresSeason,
			workflow_status_id: data.replacementVehicle.workflow_status_id,
			registration_number: data.replacementVehicle.registration_number,
			type_of_use: data.replacementVehicle.type_of_use,
			department,
			vignette: data.replacementVehicle.vignette,
		}
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLE_CREATE);
			ReplacementVehiclesService.create(requestData)
				.then(data => {
					commit(REPLACEMENT_VEHICLE_CREATE_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(REPLACEMENT_VEHICLE_CREATE_ERROR, error);
					reject(error);
				});
		});
	},
	[REPLACEMENT_VEHICLE_DELETE]: ({ commit }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLE_DELETE);
			ReplacementVehiclesService.delete(requestData)
				.then(responseData => {
					commit(REPLACEMENT_VEHICLE_DELETE_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(REPLACEMENT_VEHICLE_DELETE_ERROR, error);
					reject(error);
				});
		});
	},
	[REPLACEMENT_VEHICLES_LIST_FILTERED]: ({ commit }, data) => {
		let requestData = {
			size: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
		}
		if (data.tableProps.inputFilter.vin) {
			requestData.vinFilter = data.tableProps.inputFilter.vin;
		}
		if (data.tableProps.inputFilter.annualServiceDate) {
			requestData.annualServiceDateFilter = data.tableProps.inputFilter.annualServiceDate;
		}
		if (data.tableProps.inputFilter.registrationDate) {
			requestData.registrationDateFilter = data.tableProps.inputFilter.registrationDate;
		}
		if (data.tableProps.inputFilter.responsiblePerson) {
			requestData.responsiblePersonFilter = data.tableProps.inputFilter.responsiblePerson;
		}
		if (data.tableProps.inputFilter.workflowStatus) {
			requestData.workflowStatusFilter = data.tableProps.inputFilter.workflowStatus;
		}
		if (data.tableProps.inputFilter.registrationNumber) {
			requestData.registrationNumberFilter = data.tableProps.inputFilter.registrationNumber;
		}
		if (data.tableProps.inputFilter.typeOfUse) {
			requestData.typeOfUseFilter = data.tableProps.inputFilter.typeOfUse;
		}
		if (data.tableProps.inputFilter.department) {
			requestData.departmentFilter = data.tableProps.inputFilter.department;
		}
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLES_LIST_FILTERED);
			ReplacementVehiclesService.listFiltered(requestData)
				.then(responseData => {
					commit(REPLACEMENT_VEHICLES_LIST_FILTERED_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(REPLACEMENT_VEHICLES_LIST_FILTERED_ERROR, error);
					reject(error);
				});
		});
	},
	[REPLACEMENT_VEHICLES_ALL]: ({ commit }, data) => {
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLES_ALL);
			ReplacementVehiclesService.all()
				.then(responseData => {
					commit(REPLACEMENT_VEHICLES_ALL_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(REPLACEMENT_VEHICLES_ALL_ERROR, error);
					reject(error);
				});
		});
	},
	[USER_REPLACEMENT_VEHICLES_DEPARTMENT_FILTER]: ({ commit, dispatch }, data) => {
		commit(USER_REPLACEMENT_VEHICLES_DEPARTMENT_FILTER, data);
	},
	[REPLACEMENT_VEHICLE_CHANGE_IMAGE]: ({ commit, dispatch }, data) => {
		let requestData = new FormData();
		requestData.append('id', data.id);
		if (data.imageData) {
			requestData.append('image', data.imageData);
		}
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLE_CHANGE_IMAGE);
			ReplacementVehiclesService.changeImage(requestData).then(responseData => {
				commit(REPLACEMENT_VEHICLE_CHANGE_IMAGE_SUCCESS);
				resolve(responseData);
			})
			.catch(error => {
				commit(REPLACEMENT_VEHICLE_CHANGE_IMAGE_ERROR, error);
				reject(error);
			});
		});
	},
	[REPLACEMENT_VEHICLE_GET_LATEST_KM_AND_FUEL]: ({ commit }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLE_GET_LATEST_KM_AND_FUEL);
			ReplacementVehiclesService.getLatestKmAndFuel(requestData)
				.then(responseData => {
					commit(REPLACEMENT_VEHICLE_GET_LATEST_KM_AND_FUEL_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(REPLACEMENT_VEHICLE_GET_LATEST_KM_AND_FUEL_ERROR, error);
					reject(error);
				});
		});
	},
	[REPLACEMENT_VEHICLE_GET_PREVIOUS_AND_NEXT_RESERVATION]: ({ commit }, data) => {
		let requestData = {
			id: data.id,
			startsOn: data.startsOn
		}
		return new Promise((resolve, reject) => {
			commit(REPLACEMENT_VEHICLE_GET_PREVIOUS_AND_NEXT_RESERVATION);
			ReplacementVehiclesService.getPreviousAndNextReservation(requestData)
				.then(responseData => {
					commit(REPLACEMENT_VEHICLE_GET_PREVIOUS_AND_NEXT_RESERVATION_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(REPLACEMENT_VEHICLE_GET_PREVIOUS_AND_NEXT_RESERVATION_ERROR, error);
					reject(error);
				});
		});
	},
};

const mutations = {
	[REPLACEMENT_VEHICLE_CREATE]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLE_CREATE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLE_CREATE_ERROR]: state => {
		state.status = 'error';
	},
	[REPLACEMENT_VEHICLE_DELETE]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLE_DELETE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLE_DELETE_ERROR]: state => {
		state.status = 'error';
	},
	[REPLACEMENT_VEHICLES_LIST_FILTERED]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLES_LIST_FILTERED_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLES_LIST_FILTERED_ERROR]: state => {
		state.status = 'error';
	},
	[REPLACEMENT_VEHICLES_ALL]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLES_ALL_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLES_ALL_ERROR]: state => {
		state.status = 'error';
	},
	[USER_REPLACEMENT_VEHICLES_DEPARTMENT_FILTER]: (state, responseData) => {
		state.status = 'success';
		Vue.set(state, 'userReplacementVehiclesDepartmentFilter', responseData);
	},
	[REPLACEMENT_VEHICLE_CHANGE_IMAGE]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLE_CHANGE_IMAGE_SUCCESS]: (state,) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLE_CHANGE_IMAGE_ERROR]: state => {
		state.status = 'error';
	},
	[REPLACEMENT_VEHICLE_GET_LATEST_KM_AND_FUEL]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLE_GET_LATEST_KM_AND_FUEL_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLE_GET_LATEST_KM_AND_FUEL_ERROR]: state => {
		state.status = 'error';
	},
	[REPLACEMENT_VEHICLE_GET_PREVIOUS_AND_NEXT_RESERVATION]: state => {
		state.status = 'loading';
	},
	[REPLACEMENT_VEHICLE_GET_PREVIOUS_AND_NEXT_RESERVATION_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[REPLACEMENT_VEHICLE_GET_PREVIOUS_AND_NEXT_RESERVATION_ERROR]: state => {
		state.status = 'error';
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};